import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
const initialState = {
    userType: null,
    defaultStore: null,
    selectedStoreId: null, // Add selectedStoreId to persist store selection
    businessId: null,
    user: {}, // Add user data to persist profile information
    businessSetup1: null,
    businessSetup2: null,
    businessSetup3: null,
    businessSetup4: null,
    businessSetup5: null,
    store: {},
    loadingStore: false,
    menu: {},
    loadingMenu: false,
    error: null,
};

const authSlice = createSlice({
    name: "business",
    initialState,
    reducers: {
        setDefaultStore(state, action) {
            state.defaultStore = action.payload;
        },
        setSelectedStoreId(state, action) {
            state.selectedStoreId = action.payload;
        },
        setBusinessId(state, action) {
            state.businessId = action.payload;
        },
        setUserType(state, action) {
            state.userType = action.payload;
        },
        setUser(state, action) {
            state.user = action.payload;
        },
        setBusinessSetup1(state, action) {
            state.businessSetup1 = action.payload;
        },
        setBusinessSetup2(state, action) {
            state.businessSetup2 = action.payload;
        },
        setBusinessSetup3(state, action) {
            state.businessSetup3 = action.payload;
        },
        setBusinessSetup4(state, action) {
            state.businessSetup4 = action.payload;
        },
        setBusinessSetup5(state, action) {
            state.businessSetup5 = action.payload;
        },
        clearState(state, action) {
            state.defaultStore = null;
            state.selectedStoreId = null; // Clear selected store on logout
            state.userType = null;
            state.businessId = null;
            state.user = {}; // Clear user data on logout
            state.store = [];
            state.menu = [];
            state.businessSetup1 = [];
            state.businessSetup2 = [];
            state.businessSetup3 = [];
            state.businessSetup4 = [];
            state.businessSetup5 = [];
        },
    },
});

export const {
    setDefaultStore,
    setSelectedStoreId,
    setBusinessId,
    setBusinessSetup1,
    setBusinessSetup2,
    setBusinessSetup3,
    setBusinessSetup4,
    setBusinessSetup5,
    setUserType,
    setUser,
    clearState,
} = authSlice.actions;

export default authSlice.reducer;
